import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
import React from "react";
import { Typography, RaiseColors } from "componentLibrary";
import { DateField } from "components/mui/Fields";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var DateRangeFilter = function DateRangeFilter(_ref) {
  var filterGroupName = _ref.filterGroupName,
    minDateFilterName = _ref.minDateFilterName,
    maxDateFilterName = _ref.maxDateFilterName,
    values = _valuesInstanceProperty(_ref),
    onChange = _ref.onChange;
  return /*#__PURE__*/_jsxs("div", {
    style: {
      display: "flex",
      flexDirection: "column",
      margin: "8px 0px"
    },
    children: [filterGroupName && /*#__PURE__*/_jsx(Typography, {
      style: {
        margin: "8px 0px"
      },
      color: RaiseColors.neutral500,
      weight: "semibold",
      variant: "overline_small",
      children: filterGroupName
    }), /*#__PURE__*/_jsxs("div", {
      style: {
        display: "flex",
        marginTop: 8
      },
      children: [/*#__PURE__*/_jsx("div", {
        style: {
          width: 170
        },
        children: /*#__PURE__*/_jsx(DateField, {
          name: minDateFilterName,
          value: values === null || values === void 0 ? void 0 : values[minDateFilterName],
          placeholder: "MM/YYYY",
          onChange: onChange,
          hideSuffix: true,
          popperPlacement: "bottom-end"
        })
      }), /*#__PURE__*/_jsx("div", {
        style: {
          marginLeft: 16,
          width: 170
        },
        children: /*#__PURE__*/_jsx(DateField, {
          name: maxDateFilterName,
          value: values === null || values === void 0 ? void 0 : values[maxDateFilterName],
          placeholder: "MM/YYYY",
          onChange: onChange,
          hideSuffix: true,
          popperPlacement: "bottom-end"
        })
      })]
    })]
  });
};
export default DateRangeFilter;